/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PermissionStatus {
  ALLOW = 'allow',
  DENY = 'deny',
}
